/* DataExport.js */

"use strict";
//const Registrations = require("../../../RegistrationNamespaces");

module.exports = {
    name: "data_export",
    label: "Data Export",
    disabled: false,
    app: "GameConsole",
    order: 10, // Depricated -- Newer solution uses order from index.js
    section: "ReportCenter",
    license: ["GLUWARE"],
    accessPerm: ["dataExportAccess"],
    pageTitle: "Gluware Data Export",
    helpLink: "Data%20Export/Export-lists-from-Data-Export.htm",
    navIcon: "dataexport.solution",
    iconName: "branding.dataExport",
};
